// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1CheW","info":"Note_info__3zB4G","note":"Note_note__D57XY","actions":"Note_actions__3vpoh"};